
import React from 'react';
import { motion } from 'framer-motion';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Technology from './components/Technology';
import WhyBloomHive from './components/WhyBloomHive';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Projects from './components/Projects';
import AdminPanel from './components/AdminPanel';
import AdminAuth from './components/AdminAuth';

const App: React.FC = () => {
  return (
    <Router>
      <div className="bg-[#000000] min-h-screen selection:bg-violet-900/30">
        <Routes>
          <Route path="/" element={
            <motion.main
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
              className="relative"
            >
              <Navbar />
              <Hero />
              <About />
              <Services />
              <Technology />
              <WhyBloomHive />
              <CTA />
              <Footer />
              
              {/* Subtle global background glow */}
              <div className="fixed top-0 left-0 w-full h-full pointer-events-none z-[-1] overflow-hidden">
                <div className="absolute top-[-10%] right-[-10%] w-[50%] h-[50%] bg-violet-900/5 blur-[120px] rounded-full" />
                <div className="absolute bottom-[-10%] left-[-10%] w-[40%] h-[40%] bg-violet-900/5 blur-[120px] rounded-full" />
              </div>
            </motion.main>
          } />
          <Route path="/projects" element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <Navbar />
              <Projects />
            </motion.div>
          } />
          <Route path="/admin" element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <AdminPanel />
            </motion.div>
          } />
          <Route path="/admin/auth" element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <AdminAuth onAuthenticated={() => window.location.href = '/admin'} />
            </motion.div>
          } />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
